import React from "react";
import { useCompare } from "../contexts/CompareContext";
import { GitCompareArrows } from "lucide-react";
import { toast } from "sonner";

/**
 * Tiny compare-toggle button. Designed to overlay on CarCard.
 * Avoids triggering parent <Link> via stopPropagation + preventDefault.
 */
export function CompareToggleButton({ listingId, variant = "icon", className = "" }) {
  const { has, toggle, count, max } = useCompare();
  const active = has(listingId);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const res = toggle(listingId);
    if (res?.reason === "max") {
      toast.error(`Max ${max} Fahrzeuge gleichzeitig vergleichbar`);
      return;
    }
    if (active) {
      toast.success("Aus Vergleich entfernt");
    } else {
      toast.success(`Zum Vergleich hinzugefügt (${count + 1}/${max})`);
    }
  };

  if (variant === "full") {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold transition-colors ${
          active
            ? "border-red-500 bg-red-600/15 text-red-300"
            : "border-zinc-700 bg-zinc-900 text-zinc-200 hover:border-red-500/40 hover:text-white"
        } ${className}`}
        data-testid={`compare-toggle-${listingId}`}
        aria-pressed={active}
      >
        <GitCompareArrows className="h-4 w-4" />
        {active ? "Im Vergleich" : "Vergleichen"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title={active ? "Aus Vergleich entfernen" : "Zum Vergleich hinzufügen"}
      className={`inline-flex h-8 w-8 items-center justify-center rounded-full border backdrop-blur-md transition-all ${
        active
          ? "border-red-500 bg-red-600 text-white shadow-lg shadow-red-600/30"
          : "border-white/10 bg-black/60 text-zinc-200 hover:border-red-500/40 hover:text-white"
      } ${className}`}
      data-testid={`compare-toggle-${listingId}`}
      aria-pressed={active}
    >
      <GitCompareArrows className="h-4 w-4" />
    </button>
  );
}
